import {v4 as uuidv4} from 'uuid';

export class Character {
  constructor() {
    this.id = uuidv4();
    this.name = '';
    this.description = '';
    this.disclaimer = null;
    this.isDefault = false;
    this.image = null;
    this.imageFile = null;
    this.imagePreview = null;
    this.orderUuid = null;
    this.defaultId = null;
    this.subOrderUuid = null;
  }

  map(character) {
    this.id = character.id;
    this.name = character.name;
    this.description = character.description;
    this.disclaimer = character.disclaimer;
    this.isDefault = character.is_default;
    this.image = character.path;

    if (character.order_uuid) this.orderUuid = character.order_uuid;
    if (character.sub_order_uuid) this.subOrderUuid = character.sub_order_uuid;

    return this;
  }

  update(character) {
    if (character.id) this.id = character.id;
    if (character.name) this.name = character.name;
    if (character.description) this.description = character.description;
    if (character.disclaimer) this.disclaimer = character.disclaimer;
    if (character.isDefault === false || character.isDefault === true) this.isDefault = character.is_default;
    if (character.imageFile) this.imageFile = character.imageFile;
    if (character.imagePreview) this.imagePreview = character.imagePreview;
    if (character.orderUuid) this.orderUuid = character.orderUuid;
    if (character.defaultId) this.defaultId = character.defaultId;
    if (character.subOrderUuid) this.subOrderUuid = character.subOrderUuid;

    return this;
  }

  uploadImage(data) {
    this.imageFile = data.file;
    this.imagePreview = data.preview;

    return this;
  }
}
